module.exports = {
	"ha": "bc",
	"id": 5.3,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Age Category, Year Ending 2023 Q4 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -165,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 73.58024691358025,
						"dataLabels": {
							"enabled": true,
							"format": "298",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 70.12345679012346,
						"dataLabels": {
							"enabled": true,
							"format": "284",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 66.41975308641975,
						"dataLabels": {
							"enabled": true,
							"format": "269",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 57.03703703703704,
						"dataLabels": {
							"enabled": true,
							"format": "231",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 45.67901234567901,
						"dataLabels": {
							"enabled": true,
							"format": "185",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 93.22328410078194,
						"dataLabels": {
							"enabled": true,
							"format": "1073",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 85.83840139009557,
						"dataLabels": {
							"enabled": true,
							"format": "988",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 81.84187662901824,
						"dataLabels": {
							"enabled": true,
							"format": "942",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 72.37185056472633,
						"dataLabels": {
							"enabled": true,
							"format": "833",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 55.43006081668115,
						"dataLabels": {
							"enabled": true,
							"format": "638",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 94.35215946843853,
						"dataLabels": {
							"enabled": true,
							"format": "1704",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.21926910299004,
						"dataLabels": {
							"enabled": true,
							"format": "1521",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 81.11849390919159,
						"dataLabels": {
							"enabled": true,
							"format": "1465",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.36655592469546,
						"dataLabels": {
							"enabled": true,
							"format": "1325",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 55.48172757475083,
						"dataLabels": {
							"enabled": true,
							"format": "1002",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 93.91452462062558,
						"dataLabels": {
							"enabled": true,
							"format": "6065",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 81.9603592443481,
						"dataLabels": {
							"enabled": true,
							"format": "5293",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.04924125116135,
						"dataLabels": {
							"enabled": true,
							"format": "5105",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 75.22452771755962,
						"dataLabels": {
							"enabled": true,
							"format": "4858",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 61.56704862186435,
						"dataLabels": {
							"enabled": true,
							"format": "3976",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -26.41975308641975,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.697986577181212,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.2816901408450745,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.12639405204461,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -19.913419913419915,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -6.7767158992180665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.921714818266546,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.655870445344135,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.571125265392778,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -23.4093637454982,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -5.6478405315614655,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.739436619718312,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.6817882971729166,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.55631399317406,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -24.37735849056604,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -6.085475379374417,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.728771640560598,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.5518609484224473,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.838393731635648,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.155619596541783,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=405"
			},
			{
				"x": 9,
				"text": "30–39<br>n=1151"
			},
			{
				"x": 15,
				"text": "40–49<br>n=1806"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=6458"
			}
		],
		"dataTable": {
			"< 30": [
				405,
				298,
				284,
				269,
				231,
				185
			],
			"30–39": [
				1151,
				1073,
				988,
				942,
				833,
				638
			],
			"40–49": [
				1806,
				1704,
				1521,
				1465,
				1325,
				1002
			],
			"≥ 50": [
				6458,
				6065,
				5293,
				5105,
				4858,
				3976
			]
		}
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_3.json
// module id = 168
// module chunks = 0